import { call, put, select } from 'redux-saga/effects'
import req from '@sportninja/common/api/request'
import actions from '../actions/registrationInvite'
import { generateSagas } from './utils'

const SESSION_TOKEN = 'session_token'

const api = {
  getInviteInfo: async (inviteId) => {
    const response = await req(`/registratiton/${inviteId}`)
    return { invite: response.data }
  },
  getUserInformation: async (shouldFetchUserInfo, scheduleId, reduxUser) => {
    let userData = null
    if (shouldFetchUserInfo) {
      userData = reduxUser?.id ? reduxUser : (await req('/users/me2'))?.data
    }
    const teams = await req(
      `/users/me/team-officials/registration/schedule/${scheduleId}`
    )
    return { user: userData, teams: teams?.data }
  },
  getPlayerInformation: async (shouldFetchUserInfo, scheduleId, reduxUser) => {
    let userData = null
    if (shouldFetchUserInfo) {
      userData = reduxUser?.id ? reduxUser : (await req('/users/me2'))?.data
    }
    const teams = await req(`/registration/${scheduleId}/admin/player/teams`)
    const skillLevel = await req('/sports/skill-level-tiers')
    return {
      user: userData,
      teams: teams?.data,
      player: {},
      skillLevel: skillLevel?.data,
    }
  },
  registerTeam: async ({
    teamId,
    registrationId,
    scheduleId,
    teamOfficials,
    couponCodeId,
    zipCode,
    country,
  }) => {
    const composeTeamOfficials = teamOfficials.map((el) => ({
      email: el.email,
      name_first: el.firstName,
      name_last: el.lastName,
      phone: el.phone,
      team_official_type_id: Number(el.type),
      is_treasurer: el.isTreasurer,
    }))

    const response = await req(`/registration/${scheduleId}`, {
      method: 'POST',
      body: JSON.stringify({
        team_id: teamId,
        schedule_registration_id: registrationId,
        coupon_code_id: couponCodeId,
        is_deposit_required: true,
        is_comp: false,
        postal_code: zipCode,
        country_code: country,
        officials: composeTeamOfficials,
      }),
    })

    const teamPlayerRoster = response?.data?.team_player_roster_id
    const billing = await req(
      `/teams/${teamId}/rosters/${teamPlayerRoster}/billing`
    )

    return {
      ...response.data,
      billing: billing?.data,
    }
  },
  registerPlayer: async ({ rosterId, scheduleId, teamId, playerInfo }) => {
    // Player registration endpoint - actual implementation depends on API
    const response = await req(
      `/registration/${scheduleId}/player`,
      {
        method: 'POST',
        body: JSON.stringify({
          roster_id: rosterId,
          team_id: teamId,
          ...playerInfo,
        }),
      }
    )
    return response.data
  },
}

const registrationInviteSagas = [
  [
    actions.fetchEventInfo,
    function* ({ inviteId }) {
      const result = yield call(api.getInviteInfo, inviteId)
      const existingToken = localStorage.getItem(SESSION_TOKEN)
      yield put(
        actions.fetchEventInfo.success({
          invite: result.invite,
          isLogged: !!existingToken,
        })
      )
      return result
    },
  ],
  [
    actions.confirmTeamRepStep,
    function* ({ scheduleId }) {
      const reduxUser = yield select((state) => state.auth.user)
      const userExtraInfo = yield select(
        (state) => state.registrationInvite.userExtraInfo
      )
      const shouldFetchUserInfo = Object.keys(userExtraInfo).length === 0
      const result = yield call(
        api.getUserInformation,
        shouldFetchUserInfo,
        scheduleId,
        reduxUser
      )
      yield put(
        actions.confirmTeamRepStep.success({
          user: result.user,
          teams: result.teams,
        })
      )
      return result
    },
  ],
  [
    actions.confirmPlayerStep,
    function* ({ scheduleId }) {
      const reduxUser = yield select((state) => state.auth.user)
      const userExtraInfo = yield select(
        (state) => state.registrationInvite.userExtraInfo
      )
      const shouldFetchUserInfo = Object.keys(userExtraInfo).length === 0
      const result = yield call(
        api.getPlayerInformation,
        shouldFetchUserInfo,
        scheduleId,
        reduxUser
      )
      yield put(
        actions.confirmPlayerStep.success({
          user: result.user,
          player: result.player,
          teams: result.teams,
          skillLevel: result.skillLevel,
        })
      )
      return result
    },
  ],
  [
    actions.confirmTeamAndDivisionSelect,
    function* ({
      teamOfficials,
      teamId,
      registrationId,
      scheduleId,
      info,
      couponCodeId,
    }) {
      const result = yield call(api.registerTeam, {
        teamId,
        registrationId,
        scheduleId,
        teamOfficials,
        couponCodeId: couponCodeId || null,
        zipCode: info.zipCode,
        country: info.country,
      })
      yield put(
        actions.confirmTeamAndDivisionSelect.success({
          info,
          billing: result.billing,
        })
      )
      return result
    },
  ],
  [
    actions.confirmPlayerSelect,
    function* ({ endpointInfo, playerInfo }) {
      yield call(api.registerPlayer, {
        rosterId: endpointInfo.rosterId,
        scheduleId: endpointInfo.scheduleId,
        teamId: endpointInfo.teamId,
        playerInfo,
      })
      yield put(
        actions.confirmPlayerSelect.success({
          playerInfo,
          endpointInfo,
        })
      )
      return
    },
  ],
]

export default generateSagas([...registrationInviteSagas])
